import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/agency/";

export default class AgencyApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getAgencies(params) {
    return await request.post(`${rootRoute}getAgencies`, {
      filter: params,
      parameters: {},
    });
  }
  async getAgency(id) {
    return await request.post(`${rootRoute}getAgencies`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createAgency(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createAgency`, { data });
  }
  async deleteAgency(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteAgency`, { data });
  }
  async editAgency(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAgency`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importAgency`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getAgencyimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportAgency`, {
      filter: filter,
      format: format
    });
  }
}
